<template>
  <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm scroll_y"
    size="large"
    status-icon
  >
    <el-form-item label="文章标题" prop="title">
      <el-input
        class="big_input"
        clearable
        v-model="ruleForm.title"
        placeholder="请填写文章标题"
      />
    </el-form-item>
    <el-form-item label="所属分类" prop="categoryId">
      <el-cascader
        class="middle_input"
        ref="seconeLevelCascader"
        v-model="ruleForm.categoryId"
        :options="categoryList"
        :props="{ value: 'id', label: 'name', children: 'children' }"
        @change="changeCategory"
        placeholder="请选择所属分类"
        popper-class="cascader"
      />
    </el-form-item>
    <el-form-item label="文章来源" prop="source">
      <el-select
        v-model="ruleForm.source"
        class="m-2 small_input"
        placeholder="请选择文章来源"
        size="large"
      >
        <el-option
          v-for="item in $constGlobal.articleSource"
          :key="item.key"
          :label="item.value"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="Tdk关键字" prop="keywordList">
      <el-col :span="24">
        <el-tag
          v-for="(item, index) in ruleForm.keywordList"
          :key="item"
          closable
          @close="delTag(index, ruleForm.keywordList)"
        >
          {{ item }}
        </el-tag>
      </el-col>
      <el-col v-if="ruleForm.keywordList.length !== 6">
        <el-tooltip
          effect="dark"
          content="单个关键字2-8个字，关键字数目不能超过6个,便于搜索引擎收录页面"
          placement="top-start"
        >
          <el-input
            class="small_input"
            v-model="keyword"
            placeholder="请输入Tdk关键字"
            maxlength="8"
            clearable
          ></el-input>
        </el-tooltip>
        <el-button
          v-if="ruleForm.keywordList.length !== 6"
          type="primary"
          @click="addTag(keyword, ruleForm.keywordList)"
          plain
        >
          <el-icon> <Plus /> </el-icon>&nbsp;添加
        </el-button>
      </el-col>
    </el-form-item>
    <el-form-item label="文章跳转URL" prop="url">
      <el-input
        class="middle_input"
        clearable
        v-model="ruleForm.url"
        placeholder="请输入文章跳转URL"
      />
    </el-form-item>
    <el-form-item label="阅读次数" prop="readingCount" v-if="editId > 0">
      <el-input
        class="small_input"
        clearable
        type="number"
        v-model.number="ruleForm.readingCount"
        placeholder="请输入阅读次数"
      />
    </el-form-item>
    <el-form-item label="" prop="">
      <el-checkbox
        v-model="ruleForm.istj"
        label="是否推荐"
        size="large"
        border
      />
      <el-checkbox
        v-model="ruleForm.isjd"
        label="是否焦点"
        size="large"
        border
      />
      <el-checkbox
        v-model="ruleForm.ispl"
        label="是否评论"
        size="large"
        border
      />
      <!-- <el-checkbox
        v-model="ruleForm.dyvote"
        label="是否推送"
        size="large"
        border
      /> -->
    </el-form-item>
    <el-form-item label="所属院校专题" prop="channelIdList">
      <SchoolProjects
        :channel-list="editchannelIdList"
        :specialTypesList="specialTypesList"
        @change-channel="changeChannel"
      ></SchoolProjects>
    </el-form-item>

    <!-- 选择专题访谈 -->
    <div v-if="studentInterview">
  <el-form-item label="学生姓名" prop="studentName">
          <el-input
            class="small_input"
            clearable
            type="text"
            v-model.number="ruleForm.studentName"
            placeholder="请输入学生姓名"
          />
        </el-form-item>
         <el-form-item label="学生院校" prop="schoolName">
          <el-input
            class="small_input"
            clearable
            type="text"
            v-model.number="ruleForm.schoolName"
            placeholder="请输入学生院校"
          />
        </el-form-item>
         <el-form-item label="学生专业" prop="schoolMajor">
          <el-input
            class="small_input"
            clearable
            type="text"
            v-model.number="ruleForm.schoolMajor"
            placeholder="请输入学生专业"
          />
        </el-form-item>
    </div>
     

    <el-form-item label="文章图片" prop="imagePath">
      <ImgUpload
        v-if="childShow"
        :type="2"
        :limit="1"
        ref="addEditImgRef"
        :imagePath="ruleForm.imagePath"
        @change-image="changeImage"
      ></ImgUpload>
    </el-form-item>
    <el-form-item label="关联视频id" prop="videoId">
      <el-col :span="12">
        <el-input
          class="middle_input"
          clearable
          v-model="ruleForm.videoId"
          placeholder="请输入关联视频id"
        />
      </el-col>
      <el-col :span="6">
        <el-popover placement="right" :width="400" trigger="click">
          <template #reference>
            <el-button>
              <el-icon> <WarningFilled /> </el-icon>提示说明
            </el-button>
          </template>
          <div>
            如果文章中需要使用视频请输入关联视频的视频id，视频为第三方平台[保利威视]上传的视频,
            <a
              href="https://my.polyv.net/secure/video/"
              target="_blank"
              class="blue hand"
              >点击查看视频(复制视频id)</a
            >
          </div>
        </el-popover>
      </el-col>
    </el-form-item>
    <el-form-item label="文章描述" prop="description">
      <el-input
        v-model="ruleForm.description"
        maxlength="200"
        placeholder="请填写文章描述"
        show-word-limit
        type="textarea"
      />
    </el-form-item>
    <el-form-item label="文章内容" prop="content">
      <WangEditor
        v-if="childShow"
        ref="content"
        :type="1"
        :content="ruleForm.content"
        @change-content="changeContent"
      ></WangEditor>
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" size="large" @click="submitForm(ruleFormRef)"
      :disabled = "submitDisabled">提交</el-button
    >
  </div>
</template>

<script>
import {
  addArticle,
  getDetali,
  editArticle,
  getAllSpecialTopicTypes,
} from "network/articleList.js";
import {
  toRefs,
  reactive,
  ref,
  unref,
  onMounted,
  toRaw,
  computed,
  watch,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import WangEditor from "components/wangEditor/WangEditor.vue";
import ImgUpload from "components/ImgUpload.vue";
import SchoolProjects from "./SchoolProjects.vue";
import { isHttp, textFilter, isEditorNull } from "common/utils";
import constGlobal from "common/global.js";
export default {
  name: "AddEditarticleList",
  components: {
    WangEditor,
    ImgUpload,
    SchoolProjects,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
    categoryList: Array,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const seconeLevelCascader = ref();
    const addEditImgRef = ref();
    const data = reactive({
      loading: false,
      childShow: false,
      studentInterview:false,//学生访谈
      ruleForm: {
        categoryOneId: null,
        categoryId: null,
        title: "",
        imagePath: "",
        keywordList: [],
        description: "",
        url: "",
        readingCount: 0,
        isjd: 0,
        istj: 0,
        dyvote: 0,
        ispl: 0,
        pushToZzBaidu: 0,
        likedCount: 0,
        videoId: "",
        source: "",
        channelIdList: [],
        content: "",
        studentName:"",
        schoolName:"",
        schoolMajor:""
      },
      rules: {
        title: [
          { required: true, message: "请填写文章标题" },
          { min: 2, max: 50, message: "文章标题为2-50字" },
        ],
        categoryId: [
          {
            required: true,
            message: "请选择所属分类",
          },
        ],
        source: [
          {
            required: true,
            message: "请选择文章来源",
          },
        ],
        imagePath: [
          {
            required: true,
            message: "请上传文章图片",
          },
        ],
        keywordList: [
          {
            required: true,
            message: "请设置Tdk关键字",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "请填写文章描述",
          },
          { min: 20, max: 200, message: "文章描述为20-200字" },
        ],
        content: [
          { required: true, message: "请填写文章内容!", trigger: "blur" },
          { min: 50, message: "文章内容最少50个字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              let isEmpty = isEditorNull(textFilter((value).replace(/%/g, '%25')));
              if (isEmpty) {
                callback(new Error("请填写院校内容"));
              }  if ((value).replace(/%/g, '%25').length<50) {
                callback(new Error("文章内容最少50个字"));
              }  else {
                callback();
              }
            },
          },
        ],
        studentName: [{ required: true, message: "请填写学生姓名!", trigger: "blur" }],
        schoolName: [{ required: true, message: "请填写学生院校!", trigger: "blur" }],
        schoolMajor: [{ required: true, message: "请填写学生专业!", trigger: "blur" }],
      },
      keyword: "", //关键字
      specialTypesList: [],
      editchannelIdList: [],
      submitDisabled:false
    });
    // const projectData = ref();
    // const pbschoolData = ref();
    // const notpbschoolData = ref();
    onMounted(() => {
      data.ruleForm.source = constGlobal.articleSource[0].value;
      getSpecialTypes(); //获取关联类别
    });
    //编辑-获取详情
    if (props.editId > 0) {
      data.loading = true;
      getDetali(props.editId).then((result) => {
        if (result && result.code == 1) {
          data.loading = false;
          data.childShow = true;
          data.ruleForm = result.result;
          data.ruleForm.keywordList = result.result.keywords;
          data.ruleForm.isjd = data.ruleForm.isjd == 1 ? true : false;
          data.ruleForm.istj = data.ruleForm.istj == 1 ? true : false;
          // data.ruleForm.dyvote = data.ruleForm.dyvote == 1 ? true : false;
          data.ruleForm.ispl = data.ruleForm.ispl == 1 ? true : false;
          data.editchannelIdList = data.ruleForm.channelIdList;
          data.ruleForm.studentName == '未设置' ? data.ruleForm.studentName = "" : data.ruleForm.studentName;
          data.ruleForm.schoolName == '未设置' ? data.ruleForm.schoolName = "" : data.ruleForm.schoolName;
          data.ruleForm.schoolMajor == '未设置' ? data.ruleForm.schoolMajor= "" : data.ruleForm.schoolMajor;
          let stuInfo = [];
          stuInfo = data.editchannelIdList.filter((e) => e.relevanceName == '专升本学员访谈')
          if (stuInfo && stuInfo.length > 0) {
            data.studentInterview = true;
          } else {
            data.studentInterview = false;
          }
        } else {
          data.loading = false;
          ElMessage.error(result.message);
        }
      });
    } else {
      data.childShow = true;
    }

    function getSpecialTypes() {
      getAllSpecialTopicTypes()
        .then((result) => {
          if (result && result.code == 1) {
            data.specialTypesList = result.result;
          } else {
            ElMessage.error(result.messag);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //选择分类
    const changeCategory = () => {
      let secondLev = seconeLevelCascader.value.getCheckedNodes();
      let checkData = toRaw(secondLev[0].data); //选中的分类
      data.ruleForm.categoryId = checkData.id; //二级分类
      data.ruleForm.categoryOneId = checkData.superiorId; //父级分类
    };
    //添加关键字
    const addTag = (val, valAll) => {
      if (val == "" || val == null || val.length < 2) {
        ElMessage.error("请输入2-8个字");
        return false;
      }
      if (valAll.length >= 6) {
        data.keyword = "";
        ElMessage.error("最多只能设置6个");
        return false;
      }
      var index = valAll.indexOf(val);
      if (index >= 0) {
        ElMessage.error("关键字[" + val + "]已存在");
        return false;
      }
      valAll.push(val);
      data.ruleForm.keywordList = valAll;
      ElMessage({ message: "添加成功！", type: "success" });
      data.keyword = "";
    };
    //删除关键字
    const delTag = (index, valAll) => {
      valAll.splice(index, 1);
      ElMessage({ message: "删除成功！", type: "success" });
    };

    //获取图片上传组件传过来的
    const changeImage = (arr) => {
      if (arr && arr.length > 0) {
        data.ruleForm.imagePath = arr[0].url;
        ruleFormRef.value.clearValidate("imagePath");
      } else {
        data.ruleForm.imagePath = "";
      }
    };

    //获取富文本编辑器传过来的 文章内容
    const changeContent = (val) => {
      if (val) {
        data.ruleForm.content = val;
        if (data.ruleForm.content.length > 50) {
          ruleFormRef.value.clearValidate("content"); //移除校验结果
        }
      }
    };
    //获取所属院校专题组件 传过来的数据
    const changeChannel = (list) => {
      // 整合接口需要的数据channelIdList
      var newArr = [];
      list.map(function (sel, index) {
        var sevm = {};
        sevm["relevanceId"] = sel.id;
        sevm["relevanceType"] = sel.type;
        newArr[index] = sevm;
      });
      let stuInfo = [];
      stuInfo =list.filter((e)=>e.name=='专升本学员访谈')
      if(stuInfo && stuInfo.length > 0){
        data.studentInterview = true;
      }else{
        data.studentInterview = false;
      }
      data.ruleForm.channelIdList = newArr;
    };
    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd() {
      if (data.ruleForm.url && !isHttp(data.ruleForm.url)) {
        ElMessage.warning("文章跳转URL必须使用http或https开头");
        return false;
      }
      data.loading = true;
      data.ruleForm.isjd = data.ruleForm.isjd == true ? 1 : 0;
      data.ruleForm.istj = data.ruleForm.istj == true ? 1 : 0;
      // data.ruleForm.dyvote = data.ruleForm.dyvote == true ? 1 : 0;
      data.ruleForm.ispl = data.ruleForm.ispl == true ? 1 : 0;
      data.ruleForm.channelIdList.forEach((item) =>
      { delete item.articleId; delete item.relevanceName })

      let result;
      if (props.editId > 0) {
        data.ruleForm.id = props.editId;
        result = await editArticle(data.ruleForm);
      } else {
        result = await addArticle(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
        });
        if (addEditImgRef.value) {
            addEditImgRef.value.submitData(data.ruleForm.imagePath);
        }
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    }
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
      // 关闭弹窗 判断图片删除
      if (addEditImgRef.value) {
        addEditImgRef.value.cancelData();
      }
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      seconeLevelCascader,
      addEditImgRef,
      changeCategory,
      addTag,
      delTag,
      changeImage,
      changeContent,
      changeChannel,
      submitForm,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 550px;
}
>>> .el-form-item--large .el-form-item__content {
  line-height: 20px !important;
}
</style>

